// extracted by mini-css-extract-plugin
module.exports = {"pill":"Pill_pill__1gmfX","primary":"Pill_primary__2ZGB7","secondary":"Pill_secondary__bSzMD","warning":"Pill_warning__3ePCu"};